module.exports = __webpack_public_path__ + "static/img/img_3.69bd4c1c.png";